import api from '../api';
import type { PermissionKey } from '@alascorporation/access-control';

export interface StaffRole {
  id: string;
  name: string;
  isBuiltIn: boolean;
  permissionKeys: PermissionKey[];
}

function data<T>(res: { data: { data: T } }): T {
  return res.data.data;
}

export const staffRolesAdmin = {
  list: () => api.get<{ data: { roles: StaffRole[] } }>('/admin/staff-roles').then(data).then((d) => d.roles),

  get: (id: string) =>
    api.get<{ data: { roles: StaffRole[] } }>('/admin/staff-roles').then(data).then((d) => {
      const role = d.roles.find((r) => r.id === id);
      if (!role) throw new Error('Role not found');
      return role;
    }),

  permissionCatalog: () =>
    api
      .get<{ data: { permissionKeys: PermissionKey[] } }>('/admin/staff-roles/permission-catalog')
      .then(data)
      .then((d) => d.permissionKeys),

  create: (body: { name: string; permissionKeys: PermissionKey[] }) =>
    api.post<{ data: StaffRole }>('/admin/staff-roles', body).then(data),

  update: (id: string, body: { name?: string; permissionKeys?: PermissionKey[] }) =>
    api.patch<{ data: StaffRole }>(`/admin/staff-roles/${id}`, body).then(data),

  remove: (id: string) => api.delete(`/admin/staff-roles/${id}`).then(data),
};
